import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import TableProjects from "./TableRequestWork";

const BasicTable = () => {
  return (
    <React.Fragment>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb title="پروژه" pageTitle="جبهه کاری" />

        <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-1">
          <TableProjects />
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicTable;
